import { render } from "./check-box.vue?vue&type=template&id=45e8977a&scoped=true"
import script from "./check-box.vue?vue&type=script&lang=js"
export * from "./check-box.vue?vue&type=script&lang=js"

import "./check-box.vue?vue&type=style&index=0&id=45e8977a&lang=postcss&scoped=true"

import exportComponent from "/home/michael/Projekte/Eschenbach/vue-eon-filter/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e8977a"]])

export default __exports__